import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ContentModule } from 'app/layout/components/content/content.module';
import { FooterModule } from 'app/layout/components/footer/footer.module';
import { NavbarModule } from 'app/layout/components/navbar/navbar.module';
import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';

import { VerticalLayout1Component } from 'app/layout/vertical/layout-1/layout-1.component';
import { ChatPanelModule } from '../../components/chat-panel/chat-panel.module';
import { CommonDirectiveModule } from '../../../directive/common-directive.module';
import { TranslateModule } from '@ngx-translate/core';
import { AppsModule } from '../../../main/apps/apps.module';
import { UploadProgressModule } from '../../../main/apps/components/progress-bar/uploadProgress.module';

@NgModule({
    declarations: [
        VerticalLayout1Component
    ],
    imports: [
        RouterModule,

        FuseSharedModule,
        FuseSidebarModule,

        ContentModule,
        FooterModule,
        NavbarModule,
        ToolbarModule,
        ChatPanelModule,
        CommonDirectiveModule,
        TranslateModule,
        AppsModule,
        UploadProgressModule
    ],
    exports     : [
        VerticalLayout1Component
    ]
})
export class VerticalLayout1Module
{
}
